export const PROJECT_COMPLETES_CHANGED_MESSAGES = {
  GROUP_MC: 'Completes value changed for all locales',
  TRACKER: 'Completes value changed for all waves',
} as const;

export const PROJECT_GLOBAL_PRICE_OVERRIDE_LABELS = {
  GROUP_MC: 'Use the same Global Price Override for all locales',
  TRACKER: 'Use the same Global Price Override for all waves',
} as const;
